export function PracticeContent() {
  return (
    <div className="bg-card px-6 py-4">
      <div className="flex justify-center">
        <img
          src="/ebim-en-pratique.svg"
          alt=""
          width={684}
          height={1198}
          className="h-auto w-full max-w-[684px] object-contain"
        />
      </div>
    </div>
  )
}
